// useScanLogin.ts
import { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { API_URL, AppConstant } from 'AppConstant'

export enum ErrorStatus {
  error = 'error',
  warning = 'warning',
  emptyString = '',
}

export function useScanLogin() {
  const navigate = useNavigate()

  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [buttonLoading, setButtonLoading] = useState(false)
  const [errorStatus, setErrorStatus] = useState<ErrorStatus>(ErrorStatus.emptyString)

  const handleChange = (value: string) => {
    setCode(value)
    setError('')
    setErrorStatus(ErrorStatus.emptyString)
  }

  const getStudio = async () => {
    setButtonLoading(true)

    if (code === '') {
      setError('empty')
      setErrorStatus(ErrorStatus.error)
      setButtonLoading(false)
      return
    }

    const response = await axios
      .post(
        API_URL + '/auth/scan-request/login/verify',
        { clinicCode: code },
        {
          headers: {
            'X-Platform-Id': process.env.REACT_APP_PLATFORM_ID,
          },
        },
      )
      .then((res) => res)
      .catch((err) => err.response)

    if (response && response.data.code === 'success' && response.data.data) {
      const accessToken = response.data.data.accessToken
      localStorage.setItem(AppConstant.ACCESS_TOKEN_SCAN_AUTH, accessToken)

      const payload = JSON.parse(atob(accessToken.split('.')[1]))
      localStorage.setItem(AppConstant.CLINIC_ID, payload?.sub)

      navigate('/scan/home')
    } else if (response && response.data.code === 'clinic_not_found') {
      setError('no_clinic')
      setButtonLoading(false)
    } else {
      setButtonLoading(false)
    }
  }

  return {
    code,
    error,
    buttonLoading,
    errorStatus,
    handleChange,
    getStudio,
  }
}
